import { format as formater } from 'date-fns'

export function useFormatDate(date: string | Date | null, format: string) {
  const appConfig = useAppConfig()
  const locale = appConfig.locale

  if (!date) return ''
  const value = isDate(date) ? date : new Date(date?.toString())
  return isDate(value) ? formater(value, format, { locale }) : ''
}
